import { ComponentType, isValidElement, ReactElement, ReactNode } from 'react';

export function isElementOfType<P>(
  element: ReactNode,
  type: ComponentType<P>
): element is ReactElement<P> {
  if (!isValidElement(element)) return false;

  if (typeof element.type === 'string') {
    return element.type === type.name;
  } else if (typeof element.type === 'function') {
    return element.type.name === type.name;
  } else {
    return element.type === type;
  }
}

export function isInteractiveElement(element: Element | null): boolean {
  if (!element) return false;
  return (
    element.tagName === 'A' ||
    element.tagName === 'BUTTON' ||
    !!element.closest('a') ||
    !!element.closest('button')
  );
}
